import { FiPhone, FiMail, FiMapPin } from 'react-icons/fi';
import { motion } from 'framer-motion';
import { useGetUserData } from '../../../hooks/useGetUserData';
import { useDoctorQuery } from '../../../hooks/useDoctorQuery';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../../../context/LanguageContext';
import { ContactForm } from '../../ContactForm/ContactForm';
import { MapIcon } from 'lucide-react';
import { FaMap } from 'react-icons/fa6';
import { CiLocationArrow1 } from 'react-icons/ci';
import { RiMapPinLine } from 'react-icons/ri';
import { Form, Select } from 'antd';
import HeaderSection from '../CommingSoon/Header';
export const fadeInUp = {
        hidden: { opacity: 0, y: 30 },
        visible: (i = 1) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.3,
                duration: 0.6,
                ease: 'easeOut',
            },
        }),
    };
export default function PublicContact() {
    const { slug } = useParams();
    const { data: doctor } = useDoctorQuery();
    const { t } = useLanguage();

    const contactInfo = {
        phone: '+1 (555) 123-4567',
        email: 'info@healthcare.com',
        address: '123 Wellness Blvd, Healthy City, HC 12345',
        mapEmbedUrl:
            'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.0191387827946!2d-122.41941568468142!3d37.774929279759065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085809cabcdf1a9%3A0x7e4dfcd12e6af76!2sSan%20Francisco%20City%20Hall!5e0!3m2!1sen!2sus!4v1695667303275!5m2!1sen!2sus',
    };

    

    if (doctor?.isLocked) {
        return null
    }

    return (
        <div >
            <section className="relative mx-auto px-4 py-6 sm:px-6 lg:px-8 md:py-10 bg-page overflow-hidden">
                {/* Background Decorative Element */}
                <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-transparent pointer-events-none" />
                <div className="text-center mb-6">
                    <motion.h2
                        className="text-2xl md:text-4xl font-bold text-textPrimary tracking-tight"
                        initial="hidden"
                        animate="visible"
                        variants={fadeInUp}
                        custom={0}
                    >
                        {t('contact.getInTouch')}
                    </motion.h2>
                    <motion.p
                        className="mt-3 text-textPrimary/70 text-xs md:text-base max-w-2xl mx-auto"
                        initial="hidden"
                        animate="visible"
                        variants={fadeInUp}
                        custom={0.2}
                    >
                        {t('contact.description')}
                    </motion.p>
                </div>

                <div className="md:max-w-3xl mx-auto">

                    <motion.a
                        href="tel:01039456426"
                        className="flex items-center gap-3 bg-primary border border-white/20 rounded-xl px-5 py-3 mb-4 text-white hover:bg-white hover:text-primary transition-colors no-underline  hover:animate-bounce"
                        initial="hidden"
                        animate="visible"
                        variants={fadeInUp}
                        custom={0.4}
                    >
                        <div className="w-9 h-9 rounded-full bg-primary flex items-center justify-center shrink-0">
                            <FiPhone className="text-white text-base" />
                        </div>
                        <div>
                            <p className="text-[10px] md:text-xs mb-0.5">{t('contact.callUs')}</p>
                            <p className="  font-medium text-base m-0 text-left">01039456426</p>
                        </div>
                    </motion.a>
                    <ContactForm />

                </div>

            </section>
        </div>
    );
}